<template>
  <FormCard
    data-testid="self-service-form-linkedin-group-linkedin-terms-and-conditions"
    data-group-key="linkedin-terms-and-conditions"
    :title="$t('campaigns.linkedin.terms_and_conditions')"
    :class="{ 'selected-card': openCard === `${$t('campaigns.linkedin.terms_and_conditions')}` }"
    :is-open="props.openCard === `${$t('campaigns.linkedin.terms_and_conditions')}`"
    @toggle="emit('toggle', `${$t('campaigns.linkedin.terms_and_conditions')}`)"
    :completed="completedCards.has(`${$t('campaigns.linkedin.terms_and_conditions')}`)"
    @enter-pressed="handleSaveAndContinue">
    <template #form-content>
      <div class="form-section" data-testid="self-service-field-linkedin_terms">
        <div class="d-flex flex-row align-items-center">
          <LeadInput v-model="termsAndCondition" type="switch" class="w-fit"> </LeadInput>
          <div class="mb-0">
            {{ $t('campaigns.linkedin.i_agree') }}
            <a href="https://www.linkedin.com/legal/jobs-terms-conditions" target="_blank">{{
              $t('campaigns.linkedin.terms_and_conditions_part')
            }}</a
            >.
          </div>
        </div>
      </div>
      <div
        class="float-right"
        data-testid="self-service-save-action-linkedin-terms-and-conditions"
        data-i18n-key="btn.save">
        <LeadButton variant="secondary" :loading="loadingSave" @click="handleSaveAndContinue">
          {{ $t('btn.save') }}
          <template #icon>
            <IconArrowBigRightFilled size="16" stroke-width="1.5" />
          </template>
        </LeadButton>
      </div>
    </template>
  </FormCard>
</template>

<script setup lang="ts">
import FormCard from '@/components/orders/form_cards/FormCard.vue';
import LeadButton from '../generic/LeadButton.vue';
import LeadInput from '@/components/form/LeadInput.vue';
import { IconArrowBigRightFilled } from '@tabler/icons-vue';
import { ref, watch } from 'vue';
import { useToast } from 'vue-toastification';
import translator from '@/locale/translator';
import { useProviderStore } from '@/stores/providers';

const props = defineProps<{
  openCard: string | null;
  providerId: string | null | undefined;
  completedCards: Set<string>;
}>();

const emit = defineEmits<{
  (e: 'toggle', cardKey: string): void;
  (e: 'completed', currentCardKey: string, nextCardKey: string | null): void;
}>();

const toast = useToast();
const providerStore = useProviderStore();
const termsAndCondition = ref<boolean>(false);
const loadingSave = ref<boolean>(false);

const handleSaveAndContinue = async () => {
  if (termsAndCondition.value) {
    loadingSave.value = true;

    setTimeout(() => {
      loadingSave.value = false;
      providerStore.addCompletedCard(
        `${translator.get('campaigns.linkedin.terms_and_conditions')}`,
        props.providerId ?? ''
      );
      emit('completed', translator.get('campaigns.linkedin.terms_and_conditions'), null);
    }, 500);
  } else {
    toast.error(translator.get('campaigns.linkedin.terms_and_conditions_error'));
  }
};

// watch completed cards, and if the card T&C is completed, set termsAndCondition to true
watch(
  () => props.completedCards,
  (newVal) => {
    if (newVal.has(`${translator.get('campaigns.linkedin.terms_and_conditions')}`)) {
      termsAndCondition.value = true;
    }
  },
  { immediate: true }
);
</script>

<style scoped lang="scss">
.float-right {
  float: right;
}

.form-section {
  margin-bottom: 30px;
}
</style>
